// practiceType(활동 유형) → 한글 표시 라벨 매핑.
// LearningActivityTab / StudentReportPanel 등 활동 유형을 표시하는 곳에서 공용 사용.
export const PRACTICE_TYPE_LABELS = {
  // ── 기존 ──
  interaction: '문항풀이',
  pip: 'PIP',
  pip_pronunciation: 'PIP 발음',
  pip_interpretation: 'PIP 통역',
  pip_performance: 'PIP 퍼포먼스',
  writing: '작문',
  spontaneousConversation: '자유 회화',
  ai_qna: 'AI Q&A',
  translationText: '번역 텍스트',
  transText: '번역 텍스트',
  translationRecording: '번역 녹음',
  transRecording: '번역 녹음',
  interpretation: '통역',
  interp: '통역',
  MemoryInterpretation: '통역 암기',
  interpMemory: '통역 암기',
  MemoryInterpretationNotes: '통역 암기 노트',
  interpMemoryNote: '통역 암기 노트',
  InterpretingConversationSequence: '순차 통역 회화',
  InterpretingConversationComplete: '완성 통역 회화',
  speaking: '회화',
  reading: '독해',
  listening: '듣기',
  vocabulary: '어휘',
  grammar: '문법',
  cardFlip: '카드 뒤집기',
  cardMatching: '카드 매칭',
  dragAndDrop: '드래그 앤 드롭',
  pair: '짝 맞추기',
  line: '선 잇기',
  dragDrop: '드래그 앤 드롭',
  flashcard: '플래시카드',
  // ── 백엔드 확정 enum (추가분) ──
  objective: '객관식',
  subjective: '주관식',
  interaction_group: '그룹 상호작용',
  single_input: '단답 입력',
  single_input_free: '자유 입력',
  single_input_group: '그룹 입력',
  segmented_input: '분할 입력',
  segmented_input_and_select: '분할 입력+선택',
  input_and_select: '입력+선택',
  single_choice: '단일 선택',
  multiple_choice: '복수 선택',
  radio_choice: '라디오 선택',
  exclusive_choice: '배타 선택',
  exclusive_choice_free: '배타 선택(자유)',
  choice_to_blank: '빈칸 선택',
  word_select_blank: '단어 빈칸 선택',
  word_grid_selection: '단어 그리드 선택',
  text_drawing: '텍스트 드로잉',
  path_coloring: '경로 색칠',
  posi_click: '위치 클릭',
  check_list_free: '체크리스트',
  check_list_free_scoring: '체크리스트(채점)',
  ai_writing: 'AI 작문',
  // ── line_drawing_* 세부 변형 (키는 추정값, 백엔드 실제 값 확정 시 검증 필요) ──
  line_drawing_one_to_one: '선긋기 (1:1)',
  line_drawing_many_to_many: '선긋기 (다대다)',
  line_drawing_three_column: '선긋기 (3열)',
  line_drawing_input: '선긋기 (입력형)',
  line_drawing_input_and_select: '선긋기 (입력+선택)',
};

export function formatPracticeType(type) {
  if (PRACTICE_TYPE_LABELS[type]) return PRACTICE_TYPE_LABELS[type];
  // 미등록 line_drawing_* 변형이 더 오면 일단 '선긋기' 로 폴백 (원문 노출 방지)
  if (type && type.startsWith('line_drawing')) return '선긋기';
  return type;
}

// practiceType null → 'interaction' 폴백 (백엔드 정규화 전 구버전 데이터 호환)
export function resolvePracticeType(practice) {
  return practice?.practiceType || 'interaction';
}
